import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import BottomNav from "@/components/BottomNav";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";
import { ArrowLeft, BookOpen, Clock } from "lucide-react";

export default function Education() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/dashboard/me").then((r) => {
      if (!r.data?.condition) {
        navigate("/dashboard", { replace: true });
        return;
      }
      const ed = r.data?.condition?.education || [];
      setItems(ed);
    });
  }, [navigate]);

  return (
    <MobileShell>
      <header className="px-6 pt-8 pb-4">
        <button onClick={() => navigate(-1)} className="text-slate-500 mb-3" data-testid="back-btn"><ArrowLeft size={20} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600">Education library</p>
        <h1 className="text-2xl font-bold font-display text-slate-900 mt-1">Learn at your pace</h1>
      </header>

      <ul className="px-6 space-y-3" data-testid="education-list">
        {items.map((e, i) => (
          <li key={i}>
            <button
              onClick={() => setOpen(e)}
              data-testid={`edu-${i}`}
              className="w-full text-left bg-white rounded-2xl border border-slate-100 p-4 active:scale-[0.99] transition"
            >
              <div className="flex items-center gap-2 text-teal-700">
                <BookOpen size={14} />
                <span className="text-[10px] font-bold uppercase tracking-[0.15em]">{e["Resource Type"]}</span>
              </div>
              <div className="font-semibold text-slate-900 mt-1">{e["Resource Title"]}</div>
              <div className="text-xs text-slate-500 mt-1 line-clamp-2">{e["Summary"]}</div>
              <div className="text-[11px] text-slate-400 mt-2 flex items-center gap-1"><Clock size={12} /> {e["Read Time"] || "5 min"}</div>
            </button>
          </li>
        ))}
      </ul>

      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-md rounded-3xl">
          <DialogHeader>
            <DialogTitle className="text-xl font-display">{open?.["Resource Title"]}</DialogTitle>
          </DialogHeader>
          {open && (
            <div className="space-y-3 text-sm">
              <p className="text-slate-700 leading-relaxed">{open["Summary"]}</p>
              {open["Clinical Purpose"] && (
                <div>
                  <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-bold">Why this matters</div>
                  <p className="text-slate-700">{open["Clinical Purpose"]}</p>
                </div>
              )}
              {open["Key Takeaways / CTA"] && (
                <div>
                  <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-bold">Key takeaways</div>
                  <p className="text-slate-700">{open["Key Takeaways / CTA"]}</p>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      <BottomNav />
    </MobileShell>
  );
}
